<template>
  <div>
    <div>
      <vs-row class="mt-5">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="4"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-card>
            <div class="folha" v-if="dadosEvento != {}">
              <div slot="header">
                <h3>Dados do Evento</h3>
                <br />
              </div>
              <div>
                <table class="table table-bordered">
                  <tr>
                    <th class="uppercase">Protocolo</th>
                    <td>{{ dadosEvento.idEvento }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Tipo do Evento</th>
                    <td>{{ dadosEvento.tipoEvento.descricao }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Status do Evento</th>
                    <td>{{ dadosEvento.nomeStatus }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Data do Evento</th>
                    <td>{{ formataDataHora(dadosEvento.dataHoraEvento) }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Data de abertura do Evento</th>
                    <td>{{ formataDataHora(dadosEvento.createdAt) }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Tipo de colisão</th>
                    <td>{{ dadosEvento.tipoColisao.descricao }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Envolvimento</th>
                    <td>{{ dadosEvento.envolvimento }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Número do boletim</th>
                    <td>{{ dadosEvento.numeroBoletim }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Endereço do Evento</th>
                    <td>
                      {{
                        dadosEvento.enderecoEvento
                          ? dadosEvento.enderecoEvento.cep
                          : ''
                      }}
                      -
                      {{
                        dadosEvento.enderecoEvento
                          ? dadosEvento.enderecoEvento.endereco
                          : ''
                      }}
                      {{
                        dadosEvento.enderecoEvento
                          ? dadosEvento.enderecoEvento.numero
                          : ''
                      }}
                      {{
                        dadosEvento.enderecoEvento
                          ? dadosEvento.enderecoEvento.complemento
                          : ''
                      }}
                      -
                      {{
                        dadosEvento.enderecoEvento
                          ? dadosEvento.enderecoEvento.bairro
                          : ''
                      }}
                      -
                      {{
                        dadosEvento.enderecoEvento
                          ? dadosEvento.enderecoEvento.cidade
                          : ''
                      }}
                      /
                      {{
                        dadosEvento.enderecoEvento
                          ? dadosEvento.enderecoEvento.estado
                          : ''
                      }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="4"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-card>
            <div class="folha" v-if="dadosEvento != {}">
              <div slot="header">
                <h3>Beneficiário</h3>
                <br />
              </div>
              <div>
                <table
                  class="table table-bordered"
                  v-if="dadosEvento.dadosCliente"
                >
                  <tr>
                    <th class="uppercase">Código</th>
                    <td>
                      {{ dadosEvento.dadosCliente.idProspect }}
                      <router-link
                        target="_blank"
                        :to="`/DetalheAssociado/${dadosEvento.dadosCliente.idProspect}`"
                      >
                        <feather-icon
                          icon="ExternalLinkIcon"
                          svgClasses="h-4 w-4"
                        />
                      </router-link>
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">Nome</th>
                    <td>{{ dadosEvento.dadosCliente.nome }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Email</th>
                    <td>{{ dadosEvento.dadosCliente.email }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Telefone</th>
                    <td>
                      {{ dadosEvento.dadosCliente.celular }}
                      -
                      {{ dadosEvento.dadosCliente.telefone }}
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">Endereço</th>
                    <td>
                      {{ dadosEvento.dadosCliente.cep }}
                      -
                      {{ dadosEvento.dadosCliente.endereco }}
                      {{ dadosEvento.dadosCliente.numero }}
                      {{ dadosEvento.dadosCliente.complemento }}
                      -
                      {{ dadosEvento.dadosCliente.bairro }}
                      -
                      {{ dadosEvento.dadosCliente.cidade }} /
                      {{ dadosEvento.dadosCliente.estado }}
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">Tipo</th>
                    <td>{{ dadosEvento.dadosCliente.tipo }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">
                      {{
                        dadosEvento.dadosCliente.tipo == 'Pessoa Física'
                          ? 'CPF'
                          : 'CNPJ'
                      }}
                    </th>
                    <td>{{ dadosEvento.dadosCliente.cpfcnpj }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">
                      {{
                        dadosEvento.dadosCliente.tipo == 'Pessoa Física'
                          ? 'RG'
                          : 'IE'
                      }}
                    </th>
                    <td>{{ dadosEvento.dadosCliente.rgIe }}</td>
                  </tr>
                  <tr v-if="dadosEvento.dadosCliente.representanteLegal">
                    <th class="uppercase">Representante Legal</th>
                    <td>
                      {{ dadosEvento.dadosCliente.representanteLegal }} CPF:
                      {{ dadosEvento.dadosCliente.cpfRepresentante }}
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">CNH</th>
                    <td>
                      {{ dadosEvento.dadosCliente.cnh }} ({{
                        dadosEvento.dadosCliente.catCnh
                      }})
                      <br />
                      Vencimento
                      {{ dadosEvento.dadosCliente.dataVencimentoCnh }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </vs-card>
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="4"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-card>
            <div class="folha" v-if="dadosEvento != {}">
              <div slot="header">
                <h3>Veículo</h3>
                <br />
              </div>
              <div>
                <table
                  class="table table-bordered"
                  v-if="dadosEvento.dadosVeiculo"
                >
                  <tr v-if="dadosEvento.isZero">
                    <th class="uppercase">Zero KM</th>
                    <td>
                      NF: {{ dadosEvento.nf }}
                      <Br />
                      Data:{{ formataDataHoraUTC(dadosEvento.dataNf) }}
                      <br />
                      valor: {{ dadosEvento.valorNf | currency }}
                    </td>
                  </tr>
                  <tr v-if="dadosEvento.nomeGrupo">
                    <th class="uppercase">Grupo</th>
                    <td>{{ dadosEvento.nomeGrupo }}</td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.veiculoMarca">
                    <th class="uppercase">Marca</th>
                    <td>{{ dadosEvento.dadosVeiculo.veiculoMarca }}</td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.veiculoModelo">
                    <th class="uppercase">Modelo</th>
                    <td>{{ dadosEvento.dadosVeiculo.veiculoModelo }}</td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.anoFabricacao">
                    <th class="uppercase">Ano</th>
                    <td>
                      {{ dadosEvento.dadosVeiculo.anoFabricacao }} /
                      {{ dadosEvento.dadosVeiculo.anoModelo }}
                    </td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.placa">
                    <th class="uppercase">Placa</th>
                    <td>
                      {{ dadosEvento.dadosVeiculo.placa }}
                      <router-link
                        target="_blank"
                        :to="`/DetalheAssociado/${dadosEvento.dadosCliente.idProspect}`"
                      >
                        <feather-icon
                          icon="ExternalLinkIcon"
                          svgClasses="h-4 w-4"
                        />
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.renavam">
                    <th class="uppercase">Renavam</th>
                    <td>{{ dadosEvento.dadosVeiculo.renavam }}</td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.chassi">
                    <th class="uppercase">Chassi</th>
                    <td style="text-transform: uppercase">
                      {{ dadosEvento.dadosVeiculo.chassi }}
                    </td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.combustivel">
                    <th class="uppercase">Combustivel</th>
                    <td>{{ dadosEvento.dadosVeiculo.combustivel }}</td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.cilindradas">
                    <th class="uppercase">Cilindrada</th>
                    <td>{{ dadosEvento.dadosVeiculo.cilindradas }}</td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.codigoFipe">
                    <th class="uppercase">Codigo Fipe</th>
                    <td>{{ dadosEvento.dadosVeiculo.codigoFipe }}</td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.cor">
                    <th class="uppercase">Cor</th>
                    <td>{{ dadosEvento.dadosVeiculo.cor }}</td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.estadoPneu">
                    <th class="uppercase">Estado do Pneu</th>
                    <td>{{ dadosEvento.dadosVeiculo.estadoPneu }}</td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.km">
                    <th class="uppercase">km</th>
                    <td>{{ dadosEvento.dadosVeiculo.km }}</td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.valorFipe">
                    <th class="uppercase">Valor</th>
                    <td>{{ dadosEvento.dadosVeiculo.valorFipe | currency }}</td>
                  </tr>
                  <tr v-if="dadosEvento.dadosVeiculo.valorCobertura">
                    <th class="uppercase">Valor Cobertura</th>
                    <td>
                      {{ dadosEvento.dadosVeiculo.valorCobertura | currency }}
                    </td>
                  </tr>
                  <tr v-if="dadosEvento.detalhesAcessorios">
                    <th class="uppercase">Defeitos</th>
                    <td>{{ dadosEvento.detalhesAcessorios }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
      <div class="vx-row mt-5">
        <vx-card>
          <div class="mt-5" v-if="dadosEvento != {}">
            <vs-tabs alignment="fixed" v-model="passo">
              <vs-tab label="Dados Gerais" @click="updateBotoesDisponiveis()">
                <div>
                  <passo0
                    :formulario="form"
                    :dadosEvento="dadosEvento"
                    @formAlterado="alteraFormPai(0, $event)"
                    :tiposEvento="tiposEvento"
                    :tiposColisao="tiposColisao"
                    :status="status"
                  ></passo0>
                </div>
              </vs-tab>
              <vs-tab
                label="Pré-abertura associado"
                @click="updateBotoesDisponiveis()"
              >
                <div>
                  <passo1
                    :formulario="form"
                    :dadosEvento="dadosEvento"
                    @formAlterado="alteraFormPai(1, $event)"
                    :tiposEvento="tiposEvento"
                    :tiposColisao="tiposColisao"
                    :status="status"
                  ></passo1>

                  <popupFinalizacaoPreAbertura
                    v-if="showPopupFinalizacaoPreAbertura"
                    :formulario="form"
                    :dadosEvento="dadosEvento"
                    @confimed="onConfirmFinalizarPreAbertura($event)"
                    @close="toggleModalFinalizarPreAbertura(false)"
                  />
                </div>
              </vs-tab>
              <!--vs-tab label="Terceiro" @click="updateBotoesDisponiveis()">
                <div></div>
              </vs-tab>
              <vs-tab label="Análise" @click="updateBotoesDisponiveis()">
                <div></div>
              </vs-tab>
              <vs-tab label="Regulagem" @click="updateBotoesDisponiveis()">
                <div></div>
              </vs-tab>
              <vs-tab label="Cotação" @click="updateBotoesDisponiveis()">
                <div></div>
              </vs-tab>
              <vs-tab label="Acompanhamento" @click="updateBotoesDisponiveis()">
                <div></div>
              </vs-tab>
              <vs-tab
                label="Financeiro de Eventos"
                @click="updateBotoesDisponiveis()"
              >
                <div></div>
              </vs-tab>
              <vs-tab
                label="Histórico do Evento"
                @click="updateBotoesDisponiveis()"
              >
                <div></div>
              </vs-tab-->
            </vs-tabs>
          </div>
        </vx-card>
      </div>
      <div class="vx-row mt-3">
        <div class="vx-col w-full text-right">
          <BotaoSubmit
            v-for="botao in botoesSalvar"
            :key="botao.id"
            :text="botao.text"
            :variant="botao.variant"
            :edit="botao.edit"
            :aguarde="aguardeCadastro"
            class="ml-4"
            @submit="botao.submit()"
          ></BotaoSubmit>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from '../../services';
import locale from '../../locale';
import moment from 'moment';
import BotaoSubmit from '../../components/BotaoSubmit';
import passo0 from './../forms/eventos/formEvento_p0';
import passo1 from './../forms/eventos/formEvento_p1';
import popupFinalizacaoPreAbertura from './../forms/eventos/popupFinalizacaoPreAbertura';
import { decryptData } from '../../services/decryptData';

export default {
  components: {
    BotaoSubmit,
    passo0,
    passo1,
    popupFinalizacaoPreAbertura,
  },
  data() {
    return {
      aguardeCadastro: false,
      dadosEvento: {
        tipoEvento: {},
        tipoColisao: {},
        enderecoEvento: {},
        dadosAssociado: {},
      },
      showPopupFinalizacaoPreAbertura: false,
      status: [],
      tiposEvento: [],
      tiposColisao: [],
      grupos: [],
      listaCores: [],
      listaCombustiveis: [],
      fotos: [],
      form: {
        dadosGerais: {},
        preAberturaAssociado: {
          dadosAssociado: {},
        },
      },
      passo: 0,
      botoesSalvar: [],
    };
  },
  methods: {
    updateBotoesDisponiveis() {
      const botoes = [
        {
          id: 'default',
          edit: true,
          variant: 'success',
          shouldShow: () =>
            this.dadosEvento.idStatus != 5 && this.dadosEvento.idStatus != 6,
          submit: () => this.onSubmit(),
        },
        {
          id: 'finalizar-pre-abertura',
          text: 'Salvar e Finalizar Pré-Abertura',
          variant: 'primary',
          shouldShow: () => this.passo === 1,
          submit: () => this.toggleModalFinalizarPreAbertura(),
        },
      ];

      this.botoesSalvar = botoes.filter((button) => button.shouldShow());
    },
    toggleModalFinalizarPreAbertura(opened = true) {
      this.showPopupFinalizacaoPreAbertura = opened;
    },
    onSubmit() {
      const body = this.formataApiSubmitPayload();

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          this.$vs.loading();
          service
            .put('Eventos', 'alterarEventoAdm', body)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
              this.buscaDados();
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },
    alteraFormPai(passo, valoresForm) {
      const passos = [
        'dadosGerais',
        'preAberturaAssociado',
        'terceiro',
        'analise',
      ];
      this.form[passos[passo]] = valoresForm;
    },
    onConfirmFinalizarPreAbertura({
      pendenciaPreAbertura,
      dataConsultaPatios,
    }) {
      const passoPreAbertura = 'preAberturaAssociado';
      const formData = this.form[passoPreAbertura];
      formData.pendenciaPreAbertura = pendenciaPreAbertura || false;
      formData.dataConsultaPatios = dataConsultaPatios;
      formData.finalizarPreAbertura = true;

      this.toggleModalFinalizarPreAbertura(false);
      this.onSubmit();
    },
    buscaDados() {
      this.$vs.loading();
      var objSend = {};
      objSend.idEvento = this.$route.params.idEvento;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;
      service
        .post('Eventos', 'list', objSend)
        .then((res) => {
          if (res.data.eventos.length > 0) {
            this.dadosEvento = this.formataTransacao(res.data.eventos[0]);
            this.$vs.loading.close();
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Você não tem acesso a visualização deste Evento',
              color: 'danger',
            });
            this.$vs.loading.close();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
    formataTransacao(item) {
      item.idProposta = item.id_proposta;
      item.dadosVeiculo = { ...item.Eventos_Veiculo };
      item.dadosVeiculo.codTipoVeiculo =
        item.Eventos_Veiculo.Grupo_Veiculo.idTipoFipe;
      item.tipoEvento = { ...item.Eventos_TipoEvento };
      if (item.Eventos_TipoColisao)
        item.idTipoColisao = item.Eventos_TipoColisao.idTipoColisao;
      item.tipoColisao = { ...item.Eventos_TipoColisao };
      item.idStatus = item.Eventos_Status.idStatus;
      item.nomeStatus = item.Eventos_Status.nomeStatus;
      item.dataHoraContatoAssistencia = item.dataHoraContatoAssistencia
        ? this.formataDataHoraUTC(item.dataHoraContatoAssistencia)
        : null;
      item.dadosCliente = {
        ...item.Eventos_Associado,
        dataNascimento: this.formataData(item.dataNascimento),
        dataVencimentoCnh: this.formataData(item.dataVencimentoCnh),
      };
      item.enderecoEvento = JSON.parse(item.enderecoEvento);
      item.dadosCondutor = JSON.parse(item.dadosCondutor);
      item.dadosAssociado = { ...item.Eventos_Associado };

      return item;
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    formataDataHora(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    formataDataHoraUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY HH:mm');
    },
    formataDataHoraIso(data) {
      if (!data) return null;

      const datetimeFormat = 'DD/MM/YYYY HH:mm';
      const isInUTC = typeof data === 'string' && data.includes('Z');
      const momentFormat = isInUTC ? undefined : datetimeFormat;

      return moment(data, momentFormat).toISOString();
    },
    formataDataIso(data) {
      if (!data) return null;

      var dia = data.split('/')[0];
      var mes = data.split('/')[1];
      var ano = data.split('/')[2];

      return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2);
    },
    formataApiSubmitPayload() {
      return {
        ...this.form,
        idEvento: this.dadosEvento.idEvento,
        idVeiculo: this.dadosEvento.dadosVeiculo.idVeiculo,
        idPessoa: this.dadosEvento.dadosAssociado.idProspect,
        dadosGerais: {
          ...this.form.dadosGerais,
          dataHoraContatoAssistencia: this.formataDataHoraIso(
            this.form.dadosGerais.dataHoraContatoAssistencia,
          ),
          dataHoraEvento: this.formataDataHoraIso(
            this.form.dadosGerais.dataHoraEvento,
          ),
          carroReservaDataLiberacao: this.formataDataHoraIso(
            this.form.dadosGerais.carroReservaDataLiberacao,
          ),
          carroReservaDataDevolucao: this.formataDataHoraIso(
            this.form.dadosGerais.carroReservaDataDevolucao,
          ),
          enderecoEvento: JSON.stringify(
            this.form.dadosGerais.dadosLocalEvento,
          ),
          contatoAssistencia:
            this.form.dadosGerais.dataHoraContatoAssistencia !== null,
        },
        preAberturaAssociado: {
          ...this.form.preAberturaAssociado,
          dadosCondutor: JSON.stringify(
            this.form.preAberturaAssociado.dadosCondutor,
          ),
          partesDanificadas: this.form.preAberturaAssociado.partesDanificadas
            ? this.form.preAberturaAssociado.partesDanificadas.filter(
                (parte) => parte.selecionado,
              )
            : null,
          dataConsultaPatios: this.formataDataHoraIso(
            this.form.preAberturaAssociado.dataConsultaPatios,
          ),
        },
      };
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    localStorage.removeItem('formFiltro');
    this.buscaDados();
    this.buscaDadosSelects(
      'eventosSituacoes',
      'status',
      'nomeStatus',
      'idStatus',
    );
    this.buscaDadosSelects(
      'eventosMotivos',
      'tiposEvento',
      'nomeMotivo',
      'idMotivo',
    );
    this.buscaDadosSelects(
      'domTipoColisao',
      'tiposColisao',
      'descricao',
      'idTipoColisao',
    );

    this.updateBotoesDisponiveis();
  },
};
</script>
<style lang="scss">
.assinatura {
  max-width: 100%;
  max-height: 200px;
}
.vdp-datepicker input {
  width: 100%;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
